import { render, staticRenderFns } from "./CustomerTabAddresses.vue?vue&type=template&id=02918de8&scoped=true"
import script from "./CustomerTabAddresses.vue?vue&type=script&lang=ts"
export * from "./CustomerTabAddresses.vue?vue&type=script&lang=ts"
import style0 from "./CustomerTabAddresses.vue?vue&type=style&index=0&id=02918de8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02918de8",
  null
  
)

export default component.exports